<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="课堂作业"> 暂无已批改作业哦～ </a-tab-pane>
      <a-tab-pane key="2" tab="自定义作业"> 暂无已批改作业哦～ </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: "StudentWork",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
</style>